export class Content {
  private value: string

  constructor (value: string) {
    this.value = value
  }

  content (): string {
    return this.value
  }
}
